import { IDashboardPaths } from '@/types';

export const DASHBOARD_PATHS: IDashboardPaths = {
  DASHBOARD_DATA: {
    _: 'dashboard/',
  },
} as const;
